var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_3","data-name":"Path 3","d":"M-1232,9966l18.07,18.069-18.07,18.066","transform":"translate(1233.061 -9964.939)","fill":"none","stroke":"#00adee","strokeWidth":"3"}));
}

ArrowInline.defaultProps = {"viewBox":"0 0 21.252 38.257"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
